import { PENGATURAN_SIMPANAN_MONTHLY } from "redux/constants/admin/masterdata/constants";

const initialState = {
  loadingGetPengaturanSimpanan: true,
  dataPengaturanSimpanan: { count: 0, data: [] },
  selectedIds: [],
  queryKey: null,
  cache: {}, // {[key]: { data: {count, data: []}, fetchedAt, loading? }}
};

export const pengaturanSimpananMonthlyReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case PENGATURAN_SIMPANAN_MONTHLY.GET_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS:
      return {
        ...state,
        dataPengaturanSimpanan: action.data,
      };

    case PENGATURAN_SIMPANAN_MONTHLY.LOADING_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS:
      return {
        ...state,
        loadingGetPengaturanSimpanan: action.load,
      };

    // Selection
    case PENGATURAN_SIMPANAN_MONTHLY.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case PENGATURAN_SIMPANAN_MONTHLY.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case PENGATURAN_SIMPANAN_MONTHLY.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case PENGATURAN_SIMPANAN_MONTHLY.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    // Cache
    case PENGATURAN_SIMPANAN_MONTHLY.SET_CACHE_ENTRY: {
      const { key, data } = action;
      return {
        ...state,
        cache: {
          ...state.cache,
          [key]: { data, fetchedAt: Date.now(), loading: false },
        },
        dataPengaturanSimpanan: data,
        loadingGetPengaturanSimpanan: false,
      };
    }

    case PENGATURAN_SIMPANAN_MONTHLY.SET_LOADING_FOR_KEY: {
      const { key, loading } = action;
      const prev = state.cache[key] || {};
      return {
        ...state,
        cache: { ...state.cache, [key]: { ...prev, loading } },
        loadingGetPengaturanSimpanan: loading,
      };
    }

    case PENGATURAN_SIMPANAN_MONTHLY.UPDATE_CACHE_ITEMS: {
      const { changesById } = action; // { [id]: { ...partial } }
      const nextCache = {};
      for (const k in state.cache) {
        const entry = state.cache[k];
        if (!entry?.data?.data) {
          nextCache[k] = entry;
          continue;
        }
        const newList = entry.data.data.map((row) =>
          changesById[row.id] ? { ...row, ...changesById[row.id] } : row
        );
        nextCache[k] = {
          ...entry,
          data: { ...entry.data, data: newList },
        };
      }
      const activeList = state.dataPengaturanSimpanan?.data || [];
      const newActive = activeList.map((row) =>
        changesById[row.id] ? { ...row, ...changesById[row.id] } : row
      );
      return {
        ...state,
        cache: nextCache,
        dataPengaturanSimpanan: {
          ...state.dataPengaturanSimpanan,
          data: newActive,
        },
      };
    }

    default:
      return state;
  }
};
